import { useMemo } from 'react';

import { useCollateralToken } from '../components/TradeModule/store/useCollateralToken';

export const useGetPayableTokenDecimals = () => {
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());

  return useMemo(() => {
    return payToken?.decimals;
  }, [payToken]);
};
